import React, { PropsWithChildren } from "react";

export const CardBody: React.FC<PropsWithChildren<any>> = ({ children }) => {
  return (
    <div className={"rounded-lg px-4 py-8 dark:bg-neutral-800"}>{children}</div>
  );
};
